import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Bike, Plus } from 'lucide-react';

interface FloatingActionButtonProps {
  cartItems?: number;
  onCartClick?: () => void;
}

const FloatingActionButton = ({ cartItems = 0, onCartClick }: FloatingActionButtonProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      // Show FAB when user scrolls down
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50 md:hidden safe-bottom">
      <Button
        onClick={onCartClick}
        className="btn-neon rounded-full w-12 h-12 sm:w-14 sm:h-14 shadow-glow-intense hover:shadow-glow-intense transform hover:scale-110 active:scale-95 transition-all duration-200 touch-target"
        size="lg"
      >
        <div className="relative">
          {cartItems > 0 ? (
            <>
              <Bike className="h-5 w-5 sm:h-6 sm:w-6" />
              <div className="absolute -top-1.5 -right-1.5 sm:-top-2 sm:-right-2 bg-destructive text-destructive-foreground rounded-full w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center text-[10px] sm:text-xs font-bold">
                {cartItems > 9 ? '9+' : cartItems}
              </div>
            </>
          ) : (
            <Bike className="h-5 w-5 sm:h-6 sm:w-6" />
          )}
        </div>
      </Button>
    </div>
  );
};

export default FloatingActionButton;